import { colorSchemeTokens } from '@sixui/ui/themes/base/colorScheme.stylex';
import stylex from '@stylexjs/stylex';

export const commonStyles = stylex.create({
  transparentCheckerboardBackground: {
    // See: https://css-tricks.com/background-patterns-simplified-by-conic-gradients/#checkerboard
    background: `repeating-conic-gradient(color-mix(in srgb, ${colorSchemeTokens.outlineVariant} 40%, transparent) 0% 25%, transparent 0% 50%) 50% / 20px 20px`,
  },
  draftBackground: {
    background: `repeating-linear-gradient(${[
      '-45deg',
      'transparent',
      'transparent 10px',
      `${colorSchemeTokens.tertiaryContainer} 10px`,
      `${colorSchemeTokens.tertiaryContainer} 20px`,
    ].join(', ')})`,
  },
  colSpanFull: {
    gridColumn: '1 / -1',
  },
  backgroundColor: (color: string) => ({
    backgroundColor: color,
  }),
  backgroundImage: (src: string) => ({
    backgroundImage: `url(${src})`,
  }),
  outOfScreen: {
    position: 'absolute',
    left: '-9999px',
  },
});
